import React from 'react'
import ReactDOM from 'react-dom'

// Initialize why-did-you-render (must be imported before any components)
import './wdyr'

import { App as CapacitorApp } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { ScreenOrientation } from '@capacitor/screen-orientation'
import { SplashScreen } from '@capacitor/splash-screen'
import { CapacitorUpdater } from '@capgo/capacitor-updater'
import { UnleashWebProvider } from '@openfeature/unleash-web-provider'
import { OpenFeature } from '@openfeature/web-sdk'
import * as Sentry from '@sentry/react'
import { Toast } from 'antd-mobile'
import axios from 'axios'
import { UnleashClient } from 'unleash-proxy-client'

import api from 'services/api'

import App from './App'
import * as serviceWorker from './serviceWorker'

CapacitorUpdater.notifyAppReady().then(() => {
  if (Capacitor.isNativePlatform()) {
    ScreenOrientation.lock({ orientation: 'portrait' })
  }
})

CapacitorUpdater.addListener('download', info => {
  Toast.show({
    content: `Downloading ${info.percent}%`,
    duration: 0,
    maskClickable: false,
  })
})
CapacitorApp.addListener('appStateChange', async state => {
  if (state.isActive && Capacitor.isNativePlatform()) {
    try {
      const response = await api.get('/miscellaneous/signals/healthcheck')
      const newVersion = response.data?.version
      const list = await CapacitorUpdater.list()
      const appInfo = await CapacitorUpdater.current()
      const currentVersion =
        appInfo.bundle.version === 'builtin'
          ? appInfo.native
          : appInfo.bundle.version

      if (newVersion && newVersion !== currentVersion) {
        const alreadyDownloadedBundle = list.bundles.find(
          bundle => bundle.version === newVersion && bundle.status === 'pending'
        )

        let newBundleVersion = null

        if (alreadyDownloadedBundle) {
          newBundleVersion = alreadyDownloadedBundle.id
        } else {
          const fileUrl = `https://intelup-version.s3.amazonaws.com/hermes/${newVersion}/com.intelup.mobile.zip`

          try {
            const hasFileResponse = await axios.head(fileUrl)
            if (hasFileResponse.status === 200) {
              // Ensure download occurs while the app is active, or download may fail
              newBundleVersion = await CapacitorUpdater.download({
                version: newVersion,
                url: fileUrl,
              })
            } else {
              console.log('File not accessible at the URL, skipping download.')
            }
          } catch (error) {
            console.log('Error accessing file at the URL:', error.message)
          }
        }

        if (newBundleVersion) {
          SplashScreen.show()
          try {
            await CapacitorUpdater.set(newBundleVersion)
            // At this point, the new version should be active, and will need to hide the splash screen
            SplashScreen.hide()
          } catch (Exception) {
            console.log(Exception)
            SplashScreen.hide() // Hide the splash screen again if something went wrong
          }
        }
      }
    } catch (error) {
      console.error('Healthcheck failed:', error)
    }
  }
})

Sentry.init({
  dsn:
    window._env_.SENTRY_DSN ||
    'https://84557702be7b881d9178528632526903@o174223.ingest.us.sentry.io/4509667045539840',
  environment: process.env.NODE_ENV || 'development',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.captureConsoleIntegration({ levels: ['log', 'error', 'warn'] }),
    Sentry.unleashIntegration({ unleashClientClass: UnleashClient }),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  _experiments: {
    enableLogs: true,
  },
})

OpenFeature.setProvider(
  new UnleashWebProvider({
    url: 'https://unleash.intelup.com.br/api/frontend', // Unleash proxy/frontend API URL
    clientKey:
      process.env.NODE_ENV === 'development'
        ? 'default:development.1514af9ae7f91c62c2e7dd9385d7fb468d75c6deb1e0f013452afa15'
        : 'default:production.50e181ea5228618be4999efa044c6fc46720047db6d254457bc4a0df',
    refreshInterval: 60, // how often (in seconds) the provider will poll Unleash for updates
    appName: 'hermes',
  })
)

ReactDOM.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
